export default __webpack_public_path__ + "static/media/Shark_Squid.49f9a60c.svg";